meedy.factory('meedy.availabilityRuleModel', ['$rootScope', 'applicationModel', 'meedy.baseModel', 'meedy.availabilityRuleService',
    function($rootScope, applicationModel, baseModel, availabilityRuleService) {

        function AvailabilityRuleModel() {

            this.generateAppointmentTimeOptions = function(timeLengthMax) {
                var timeLength = 121;
                if(timeLengthMax) {
                    timeLength = timeLengthMax +1; //0-indexed forces us to generate additional number
                }
                return Array.apply(null, {length: timeLength}).map(Function.call, Number).filter(function(num) { return num % 5 === 0 && num != 0 });
            };

            this.getAvailabilityRuleOccurences = function(criteria) {
                availabilityRuleService.getAvailabilityRuleOccurences(criteria).then(
                    function (list) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.GET_AVAILABILITY_RULE_OCCURENCES.SUCCESS, list);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.GET_AVAILABILITY_RULE_OCCURENCES.ERROR, error);
                    }
                )
            };

            this.createAvailabilityRule = function(availabilityRule) {
                applicationModel.actionInProgress = true;
                availabilityRuleService.createAvailabilityRule(availabilityRule).then(
                    function (list) {
                        baseModel.broadcastOperationSucceeded();
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.CREATE_AVAILABILITY_RULE.SUCCESS, list);
                        applicationModel.actionInProgress = false;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.CREATE_AVAILABILITY_RULE.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.updateAvailabilityRule = function(availabilityRule) {
                applicationModel.actionInProgress = true;
                availabilityRuleService.updateAvailabilityRule(availabilityRule).then(
                    function (list) {
                        baseModel.broadcastOperationSucceeded();
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.UPDATE_AVAILABILITY_RULE.SUCCESS, list);
                        applicationModel.actionInProgress = false;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.UPDATE_AVAILABILITY_RULE.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.getAvailabilityRuleById = function(id) {
                availabilityRuleService.getAvailabilityRuleById(id).then(
                    function (list) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.GET_AVAILABILITY_RULE_BY_ID.SUCCESS, list);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.GET_AVAILABILITY_RULE_BY_ID.ERROR, error);
                    }
                )
            };

            this.getAvailabilityRule = function(criteria) {
                availabilityRuleService.getAvailabilityRule(criteria).then(
                    function (list) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.GET_AVAILABILITY_RULE.SUCCESS, list);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.GET_AVAILABILITY_RULE.ERROR, error);
                    }
                )
            };

            this.deleteAvailabilityRule = function(availabilityRule) {
                applicationModel.actionInProgress = true;
                availabilityRuleService.deleteAvailabilityRule(availabilityRule).then(
                    function (list) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.DELETE_AVAILABILITY_RULE.SUCCESS, list);
                        applicationModel.actionInProgress = false;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.DELETE_AVAILABILITY_RULE.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.getNearestAvailabilityRuleCacheOccurence = function(criteria) {
                availabilityRuleService.getNearestAvailabilityRuleCacheOccurence(criteria).then(
                    function (list) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.GET_NEAREST_AVAILABILITY_RULE_OCCURENCE.SUCCESS, list);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.GET_NEAREST_AVAILABILITY_RULE_OCCURENCE.ERROR, error);
                    }
                )
            };

            this.getAvailabilityRules = function() {
                availabilityRuleService.getAvailabilityRules().then(
                    function (list) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.GET_AVAILABILITY_RULES.SUCCESS, list);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.GET_AVAILABILITY_RULES.ERROR, error);
                    }
                )
            };

            this.checkCollisions = function(availabilityRule) {
                applicationModel.actionInProgress = true;
                availabilityRuleService.checkCollisions(availabilityRule).then(
                    function (list) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.CHECK_COLLISIONS.SUCCESS, list);
                        applicationModel.actionInProgress = false;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.AVAILABILITY_RULE.CHECK_COLLISIONS.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

        }

        return new AvailabilityRuleModel();
    }
]);
